<template>
  <v-form ref="form" @submit.prevent v-model="formValid">
    <FieldRHDHV
      v-for="(field, index) in fields"
      @change="$emit('change')"
      :key="index"
      :ref="field.name"
      :index="index"
      color="primary"
      :filled="filled"
      :model="mutableModel"
      :field-option="field"
      :dialog="dialog"
    />
  </v-form>
</template>
<script>
import FieldRHDHV from '@/components/form/Field.vue'
import OptionsFieldsMixin from '@/mixins/OptionsFieldsMixin.vue'

export default {
  name: 'FormRHDHV',
  components: { FieldRHDHV },
  mixins: [OptionsFieldsMixin],
  props: {
    model: { required: true },
    url: { required: true },
    formOrder: { required: true },
    filled: { required: false },
    dialog: {
      default: false,
      required: false
    },
    fieldsInput: {
      // Make sure this is similar to the options call format
      required: false,
      default: null
    }
  },
  watch: {
    mutableModel: {
      async handler() {
        this.$emit('form-valid-changed', this.formValid)
      },
      deep: true
    }
  },
  data: () => ({
    fields: [],
    mutableModel: null,
    formValid: false
  }),
  methods: {
    clearModel() {
      for (const property in this.mutableModel) {
        this.mutableModel[property] = null
      }
      this.$refs.form.reset()
    },
    async save() {
      let formValidation = await this.validate()
      if (formValidation.valid) {
        this.formValid = true
        this.resetValidation()
        return formValidation
      } else {
        return formValidation
      }
    },
    async validate() {
      return await this.$refs.form.validate()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  },
  async mounted() {
    this.mutableModel = this.model
    if (this.fieldsInput) {
      this.orderForm(this.fieldsInput)
    } else {
      await this.getFields()
    }
  }
}
</script>
